import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { CheckSquare, DollarSign, Edit2, Trash2 } from 'react-feather'

// Imports custom
import { TooltipInformation, CustomTableData, LinearLoading, CustomDropDown } from 'common'

export const TableLawyer = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchAllProcessLawyer } = FetchData
    const { dataProcessLawyer, loadingFetchProcessLawyer } = fetchAllProcessLawyer

    const { 
        handleClickFetchSpecificProcessLawyer,
        handleClickDeleteProcessLawyer,
        handleClickAddPayment,
        handleClickToggleSatus
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "date_start", headerName: "FECHA", minWidth: 150, filter: true },
        { field: "process_number", headerName: "ID", minWidth: 100, filter: true },
        { field: "category_process", headerName: "CATEGORIA", minWidth: 150, filter: true },
        { field: "type_process", headerName: "TIPO", minWidth: 100, filter: true },
        { field: "name_process", headerName: "PROCESO", minWidth: 200, filter: true },
        { field: "jdo_process_number", headerName: "NO. PROCESO (JDO)", minWidth: 250, filter: true },
        { field: "process_ministry", headerName: "NO. PROCESO (MP)", minWidth: 250, filter: true },
        { field: "info_cliente", headerName: "CLIENTE", minWidth: 300, filter: true },
        { 
            field: "initial_amount", headerName: "MONTO", minWidth: 125, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { field: "other_expense_total", headerName: "O. GASTOS", minWidth: 150, filter: true },
        { 
            field: "total_pagar", headerName: "T. PAGAR", minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "total_discount", headerName: "T. DESCUENTO", minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
         },
        { 
            field: "total_recibido", headerName: "RECIBIDO", minWidth: 150, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "saldo_total", headerName: "SALDO", minWidth: 150, filter: true,
            cellClass: (params) => {
                return parseFloat(params.value) !== 0 ? 'bg-danger' : 'bg-success';
            },
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { field: "date_paid", headerName: "FECHA PAGO", minWidth: 150, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idlawyer } = params.data
                const formOpeningMode = 'READONLY'
                return (
                    <CustomDropDown color="inherit">
                        <MenuItem
                            onClick={() => handleClickFetchSpecificProcessLawyer(idlawyer, formOpeningMode)}
                        >
                            <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                        {/* <MenuItem
                            onClick={() => handleClickDeleteProcessLawyer(idlawyer)}
                            disabled={formOpeningMode}
                        >
                            <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Eliminar" />
                        </MenuItem> */}
                        <MenuItem
                            onClick={() => handleClickAddPayment(idlawyer)}
                        >
                            <ListItemIcon> <DollarSign color="black"/> </ListItemIcon>
                            <ListItemText primary="Pagos" />
                        </MenuItem>
                        {/* <MenuItem
                            onClick={() => handleClickToggleSatus(idlawyer)}
                        >
                            <ListItemIcon> <CheckSquare color="black"/> </ListItemIcon>
                            <ListItemText primary="Finalizado" />
                        </MenuItem> */}
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchProcessLawyer)&&(<LinearLoading />)}
            <CustomTableData
                rowConfig={dataProcessLawyer}
                columnConfig={columnConfig}
            />
        </div>
    )
}
